/**
 * @generated SignedSource<<44858d1d0fae2a7fd2d3a88c3a96c12c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostCommentPolicy = "ALLOWED" | "RESTRICTED" | "%future added value";
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type postsUpdateQuery$variables = {
  club: string;
  slug: string;
};
export type postsUpdateQuery$data = {
  readonly club: {
    readonly groups: ReadonlyArray<{
      readonly spaces: ReadonlyArray<{
        readonly icon: string | null | undefined;
        readonly id: string;
        readonly isMember: boolean;
        readonly name: string;
        readonly slug: string;
        readonly visibility: SpaceVisibility;
      }>;
    }>;
    readonly rules: {
      readonly description: any;
      readonly title: string;
    } | null | undefined;
  };
  readonly post: {
    readonly attachments?: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly signedUrl: string;
      readonly size: string | null | undefined;
    }> | null | undefined;
    readonly commentPolicy?: PostCommentPolicy;
    readonly content?: any | null | undefined;
    readonly coverContent?: {
      readonly id?: string;
      readonly muxId?: string | null | undefined;
      readonly name?: string;
      readonly signedUrl?: string;
      readonly size?: string | null | undefined;
    } | null | undefined;
    readonly hideMetadata?: boolean;
    readonly id: string;
    readonly pinned?: boolean;
    readonly pinnedUniversal?: boolean;
    readonly scheduledPublishDate?: any | null | undefined;
    readonly slug?: string;
    readonly space?: {
      readonly id: string;
    } | null | undefined;
    readonly title?: string;
  };
};
export type postsUpdateQuery = {
  response: postsUpdateQuery$data;
  variables: postsUpdateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "club",
    "variableName": "club"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentPolicy",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledPublishDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinnedUniversal",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideMetadata",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  }
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "File",
  "abstractKey": "__isFile"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muxId",
      "storageKey": null
    }
  ],
  "type": "VideoFile",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v17 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postsUpdateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "post",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "coverContent",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "type": "Post",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v17/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceGroup",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubRules",
            "kind": "LinkedField",
            "name": "rules",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postsUpdateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "post",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "coverContent",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "type": "Post",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v17/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceGroup",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubRules",
            "kind": "LinkedField",
            "name": "rules",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v21/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16ab154fe540215bf9497577b8c59dc7",
    "id": null,
    "metadata": {},
    "name": "postsUpdateQuery",
    "operationKind": "query",
    "text": "query postsUpdateQuery(\n  $club: String!\n  $slug: String!\n) {\n  post(club: $club, slug: $slug) {\n    __typename\n    id\n    ... on Post {\n      title\n      slug\n      content\n      space {\n        __typename\n        id\n      }\n      commentPolicy\n      scheduledPublishDate\n      pinned\n      pinnedUniversal\n      hideMetadata\n      coverContent {\n        __typename\n        ... on File {\n          __isFile: __typename\n          id\n          name\n          size\n          signedUrl\n        }\n        ... on VideoFile {\n          muxId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      attachments {\n        id\n        name\n        size\n        signedUrl\n      }\n    }\n  }\n  club(slug: $club) {\n    groups {\n      spaces {\n        __typename\n        id\n        name\n        slug\n        icon\n        isMember\n        visibility\n      }\n      id\n    }\n    rules {\n      title\n      description\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "058a0993e8e2de702c2d6c96ce7c67a9";

export default node;
